import ProtectedRoute from "routes/ProtectedRoute";
import { Navigate } from "react-router-dom";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const emailRoutes = [
  {
    path: "email",
    loader: protectedRouteLoader,
    lazy: async () => {
      const [layoutMod, errorMod] = await Promise.all([
        import("components/UI/AdminLayout"),
        import("views/ErrorPage"),
      ]);

      const AdminLayout = layoutMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
    children: [
      {
        index: true,
        element: <Navigate to="campaigns" replace />,
      },
      {
        path: "campaigns",
        lazy: async () => {
          const mod = await import("views/Email/campaign");
          const Campaign = mod.default;
          return {
            Component: () => <Campaign />,
          };
        },
      },
    ],
  },
  {
    path: "email/campaigns/templates",
    lazy: async () => {
      const [pageMod, errorMod] = await Promise.all([
        import("views/Email/select-existing-template"),
        import("views/ErrorPage"),
      ]);

      const SelectExistingTemplate = pageMod.default;
      const ErrorPage = errorMod.default;

      return {
        Component: () => (
          <ProtectedRoute>
            <SelectExistingTemplate />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorPage,
      };
    },
  },
];
